import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import type { CandidateSourcingData } from '@core/candidate-types';
import type { UnwrapArray } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import { EncodeHTMLPipe, SimpleFormatPipe } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-candidate-profile-sourcing',
  templateUrl: './candidate-profile-sourcing.component.html',
  styleUrls: ['./candidate-profile-sourcing.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EncodeHTMLPipe, SimpleFormatPipe, TranslatePipe],
})
export class CandidateProfileSourcingComponent {
  @Input() public sourcing: CandidateSourcingData;

  public trackByJsonString<
    T extends
      | UnwrapArray<CandidateSourcingData['workHistory']>
      | UnwrapArray<CandidateSourcingData['educationHistory']>,
  >(index: number, entity: T): string {
    return JSON.stringify(entity, null);
  }
}
